import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import {Button, Card, Col, Row, Form, Nav, Tabs, Tab} from "react-bootstrap";
import {useEffect, useState} from "react";

function App() {


    const [regioni, setRegioni] = useState([])
    const [regione, setRegione] = useState('')

    const [province, setProvince] = useState([])
    const [provincia, setProvincia] = useState('')


    const [comuni, setComuni] = useState([])
    const [comune, setComune] = useState('')


    const [iniziative, setIniziative] = useState([])

    useEffect(() => {
        fetch("https://libriamoci.cepell.it/II/edizione/get_iniziative.php?annoIniziativa=" + '2023')
            .then(response => response.json())
            // 4. Setting *dogImage* to the image url that we received from the response above
            .then(res => setIniziative(res.data))
    }, [])


    useEffect(() => {
        fetch("https://libriamoci.cepell.it/II/edizione/get_regioni.php")
            .then(response => response.json())
            // 4. Setting *dogImage* to the image url that we received from the response above
            .then(res => setRegioni(res.data))
    }, [])

    useEffect(() => {
        fetch("https://libriamoci.cepell.it/II/edizione/get_province.php?idRegione=" + regione)
            .then(response => response.json())
            // 4. Setting *dogImage* to the image url that we received from the response above
            .then(res => setProvince(res.data))
    }, [regione !== ''])

    useEffect(() => {
        fetch("https://libriamoci.cepell.it/II/edizione/get_comuni.php?idProvincia=" + provincia)
            .then(response => response.json())
            // 4. Setting *dogImage* to the image url that we received from the response above
            .then(res => setComuni(res.data))
    }, [provincia !== ''])


    return (
        <div className="App">

            <Row>
                <Col md={3}>
                    <div className={"bg-white p-4 my-4"}>
                        <Row className={"mt-2"}>
                            <Col sm={12}>
                                <h2 className={"text-danger p-2"}>APPUNTAMENTI</h2>
                            </Col>
                        </Row>

                        <Row className={"mt-4"}>
                            <Col sm={12}>
                                <h4 className={"text-center"}>DOVE?</h4>
                            </Col>
                        </Row>
                        <Form.Group as={Row} className="mb-3" controlId="regione">
                            <Form.Label>
                                Regione
                            </Form.Label>
                            <Form.Select size={"sm"} aria-label="Default select example"
                                         onChange={e => setRegione(e.target.value)}>
                                <option value={''}></option>
                                {regioni.map((regione) => {
                                    return (
                                        <option value={regione.id}>{regione.nome}</option>
                                    )
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="provincia">
                            <Form.Label>
                                Provincia
                            </Form.Label>
                            <Form.Select size={"sm"} aria-label="Default select example"
                                         onChange={e => setProvincia(e.target.value)}>
                                <option value={''}></option>
                                {province.map((provincia) => {
                                    return (
                                        <option value={provincia.id}>{provincia.nome}</option>
                                    )
                                })}
                            </Form.Select>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3" controlId="comune">
                            <Form.Label>
                                Località
                            </Form.Label>
                            <Form.Select size={"sm"} aria-label="Default select example"
                                         onChange={e => setComune(e.target.value)}>
                                <option value={''}></option>
                                {comuni.map((comune) => {
                                    return (
                                        <option value={comune.id}>{comune.nome}</option>
                                    )
                                })}
                            </Form.Select>
                        </Form.Group>


                        <Row className={"mt-4"}>
                            <Col sm={12}>
                                <h4 className={"text-center"}>QUANDO?</h4>
                            </Col>
                        </Row>
                        <Row className={"mt-2"}>
                            <Col sm={12}>
                                <h6>Dal</h6>
                            </Col>
                        </Row>
                        <Row className={"g-3"}>
                            <Col>
                                <Form.Select size={"sm"} aria-label="Default select example"
                                             onChange={e => setRegione(e.target.value)}>
                                    <option value={'11'}>Novembre</option>
                                </Form.Select>
                            </Col>
                            <Col>
                                <Form.Select size={"sm"} aria-label="Default select example"
                                             onChange={e => setRegione(e.target.value)}>
                                    <option value={''}></option>
                                    <option value={'13'}>13</option>
                                    <option value={'14'}>14</option>
                                    <option value={'15'}>15</option>
                                    <option value={'16'}>16</option>
                                    <option value={'17'}>17</option>
                                    <option value={'18'}>18</option>
                                </Form.Select>
                            </Col>
                        </Row>

                        <Row className={"mt-2"}>
                            <Col sm={12}>
                                <h6>Al</h6>
                            </Col>
                        </Row>
                        <Row className={"g-3"}>
                            <Col>
                                <Form.Select size={"sm"} aria-label="Default select example"
                                             onChange={e => setRegione(e.target.value)}>
                                    <option value={'11'}>Novembre</option>
                                </Form.Select>
                            </Col>
                            <Col>
                                <Form.Select size={"sm"} aria-label="Default select example"
                                             onChange={e => setRegione(e.target.value)}>
                                    <option value={''}></option>
                                    <option value={'13'}>13</option>
                                    <option value={'14'}>14</option>
                                    <option value={'15'}>15</option>
                                    <option value={'16'}>16</option>
                                    <option value={'17'}>17</option>
                                    <option value={'18'}>18</option>
                                </Form.Select>
                            </Col>
                        </Row>


                        <Row className={"mt-4"}>
                            <Col sm={12}>
                                <h4 className={"text-center"}>FASCIA D'ETA'?</h4>
                            </Col>
                        </Row>
                        <Form.Group as={Row} className="mb-3" controlId="regione">
                            <Form.Select size={"sm"} aria-label="Default select example"
                                         onChange={e => setRegione(e.target.value)}>
                                <option value={''}></option>
                                <option value={'34'}>3/4</option>
                                <option value={'45'}>4/5</option>
                                <option value={'56'}>5/6</option>
                                <option value={'67'}>6/7</option>
                                <option value={'78'}>7/8</option>
                                <option value={'89'}>8/9</option>
                                <option value={'910'}>9/10</option>
                                <option value={'1011'}>10/11</option>
                                <option value={'1112'}>11/12</option>
                                <option value={'1213'}>12/13</option>
                                <option value={'1314'}>13/14</option>
                                <option value={'1415'}>14/15</option>
                                <option value={'1516'}>15/16</option>
                                <option value={'1617'}>16/17</option>
                                <option value={'1718'}>17/18</option>
                                <option value={'1819'}>18/19</option>
                            </Form.Select>
                        </Form.Group>

                        <Row className={"mt-4"}>
                            <Col sm={12}>
                                <h4 className={"text-center"}>PAROLA CHIAVE *</h4>
                            </Col>
                        </Row>
                        <Form.Group as={Row} className="mb-3" controlId="regione">
                            <Form.Control
                                size={"sm"}
                                type="text"
                            />
                        </Form.Group>
                        <p className={"text-left"}>
                            * Il testo inserito viene ricercato nel titolo, nella descrizione o nel campo ospiti
                            dell'iniziativa
                        </p>
                        <div className="d-grid gap-2">
                            <Button variant={'danger'} size={"lg"}>Cerca</Button>
                        </div>
                    </div>

                </Col>
                <Col md={9}>
                    {iniziative.map((iniziativa) => {
                        return (
                            <CardIniziativa iniziativa={iniziativa}/>
                        )
                    })}
                </Col>
            </Row>
        </div>
    );
}

export default App;


const CardIniziativa = ({iniziativa}) => {


    return (
        <Card style={{width: '100%'}} className={"my-4"}>
            <Card.Body className={"p-0"}>
                <Card.Title className={'bg-danger p-3'}>
                    <div className={"d-flex justify-content-between align-items-center"}>
                        <h4 className={"text-center fw-bold text-white"}>{iniziativa.titolo}</h4>
                        <div className={"d-flex flex-column fw-bold text-white"}>
                            <p className={"fw-bold mb-0 text-white"}>
                                UNIQUE CODE {iniziativa.uniqueCode}<br/>
                            </p>
                            <p className={"fw-bold text-white"}>
                                N. ATTIVITA': {iniziativa.nattivita}<br/>
                            </p>
                        </div>
                        <a className={"text-white"}>LINK</a>
                    </div>
                </Card.Title>
                <Card.Text className={"p-3"}>
                    <Row>
                        <Col sm={4}>
                            <h6 className={"fw-bold"}>LOCALITA'</h6>
                            <p>{iniziativa.nomeComune}</p>
                        </Col>

                        <Col sm={4}>
                            <h6 className={"fw-bold"}>REGIONE</h6>
                            <p>{iniziativa.nomeRegione}</p>
                        </Col>

                        <Col sm={4}>
                            <h6 className={"fw-bold"}>DATE</h6>
                            <ul>{iniziativa?.date.map(data => {
                                return (
                                    <li>{data}</li>
                                )
                            })}</ul>
                        </Col>
                    </Row>

                    <Row className={"mt-4"}>
                        <Col>
                            <Tabs
                                defaultActiveKey="dati-principali"
                                id="fill-tab-example"
                                className="mb-3"
                                fill
                            >
                                <Tab eventKey="dati-principali" title="Dati Principali">
                                    <h6 className={"fw-bold"}>DESCRIZIONE</h6>
                                    <p>{iniziativa.descrizione}</p>
                                    <hr/>
                                    <Row>
                                        <Col sm={6}>
                                            <h6 className={"fw-bold"}>ORDINE SCOLASTICO</h6>
                                            <p>{iniziativa.descrizioneOrdineScuola}</p>
                                        </Col>

                                        <Col sm={6}>
                                            <h6 className={"fw-bold"}>FASCE DI ETA'</h6>
                                            <p>{iniziativa.eta}</p>
                                        </Col>
                                    </Row>
                                    <hr/>
                                    <Row>
                                        <Col sm={6}>
                                            <h6 className={"fw-bold"}>FILONE TEMATICO</h6>
                                            <p>{iniziativa.denominazioneTema}</p>
                                        </Col>

                                        <Col sm={6}>
                                            <h6 className={"fw-bold"}>LOCANDINA</h6>
                                            <p>{iniziativa.eta}</p>
                                        </Col>
                                    </Row>
                                </Tab>
                                <Tab eventKey="sedi" title="Sedi">
                                    Sedi
                                </Tab>
                                <Tab eventKey="referenti" title="Referenti">
                                    Referenti
                                </Tab>
                                <Tab eventKey="lettori-volontari" title="Lettori Volontari">
                                    Lettori Volontari
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>

                </Card.Text>
            </Card.Body>
        </Card>
    )
}
